import { ref, computed, onMounted, onUnmounted, type Ref } from "vue";

export function useResultsCardVisibility(elementRef: Ref<HTMLElement | null>, force?: Ref<boolean>) {
  const intersected = ref(false);
  const revealed = ref(false);
  let observer: IntersectionObserver | null = null;
  let revealObserver: IntersectionObserver | null = null;

  onMounted(() => {
    if (!elementRef.value) return;

    observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          intersected.value = true;
          observer?.disconnect();
          observer = null;
        }
      },
      { rootMargin: "200px" },
    );

    revealObserver = new IntersectionObserver(
      ([entry]) => {
        revealed.value = entry.isIntersecting;
      },
      { rootMargin: "0px 0px -60px 0px" },
    );

    observer.observe(elementRef.value);
    revealObserver.observe(elementRef.value);
  });

  onUnmounted(() => {
    observer?.disconnect();
    revealObserver?.disconnect();
  });

  return {
    isVisible: computed(() => Boolean(force?.value) || intersected.value),
    isRevealed: computed(() => Boolean(force?.value) || revealed.value),
  };
}
